"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPreviewMailAccount = exports.base = void 0;
const organization_1 = require("./organization");
const utils_1 = require("../utils");
exports.base = Object.assign({ id: 1, organization_id: (0, organization_1.mockChildOrganization)().id, title: 'text mail', address: 'text@mail.com', imap_state: null, imap_connect_at: null, smtp_state: null, smtp_connect_at: null, imap_error: null, imap_retries: 0, smtp_error: null }, utils_1.mockDateObject);
exports.mockPreviewMailAccount = (0, utils_1.mockFunction)(Object.assign({}, exports.base));
